import * as Yup from 'yup'

const sellerInventoryBatchProcessItemSchema = Yup.object().shape({
  sku: Yup.string().required('Required')
})

export default sellerInventoryBatchProcessItemSchema